import {Route, Routes, Navigate} from "react-router-dom";
// import './App.css';
import "./css/style.min.css";
import CoffeeBlender from "./CoffeeBlender/CoffeeBlender";
import EditorNew from "./Editor/EditorNew";
import React from "react";
import UserPreferences from "./UserPreferences";
import AfterAddToCartPage from "./afterAddToCartPage";
import CoffeeSticker from "./coffeeSticker";


function App() {
  return (
    <>
      <Routes>
        <Route path="/" element={<Navigate to="/he/" replace/>}/>
        <Route path="/:lang" element={<UserPreferences/>}/>
        <Route path="/:lang/coffee-blender" element={<CoffeeBlender/>}/>
        <Route path="/:lang/editor" element={<EditorNew/>}/>
        <Route path="/:lang/after-add-to-cart" element={<AfterAddToCartPage/>}/>
        <Route path="/:lang/after-add-to-cart/:blendID" element={<AfterAddToCartPage/>}/>
        <Route path="/:lang/:coffeeID" element={<CoffeeSticker/>}/>
      </Routes>
    </>
  );
}

export default App;
